/** Link de checkout del Pack Sin Culpa, Sin Destrozos ($19.990) */
export const CHECKOUT_URL_ESTANDAR =
  'https://pack-sin-culpa-sin-destrozos.impultienda.ar/checkout'

export const socialProof = {
  lectores: '+3.570',
  rating: '4.9',
  satisfaccion: '98%',
  resenas: '+500',
}

export interface Testimonial {
  quote: string
  name: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'En 21 días mi perro pasó de destrozar la casa entera a quedarse tranquilo en su cama. Ya no salgo con culpa.',
    name: 'Carolina M.',
    location: 'Buenos Aires — Dueña de un Labrador',
  },
  {
    quote:
      'Los primeros 3 días con el ritual de salida ya noté el cambio. Antes lloraba apenas cerraba la puerta, ahora ni lo escucho.',
    name: 'Andrea P.',
    location: 'Rosario — Dueña de un Pitbull',
  },
  {
    quote:
      'Adapto el protocolo según cómo veo a mi perro ese día en minutos. Antes buscaba tips sueltos en internet y nada funcionaba en serio.',
    name: 'Luis M.',
    location: 'Córdoba — Dueño de un Puggle',
  },
  {
    quote: 'Vivo en un depto chico y los vecinos ya no se quejan. Eso solo valió el pack.',
    name: 'Paula R.',
    location: 'CABA — Dueña de un Beagle',
  },
  {
    quote: 'Lo adoptamos hace 4 meses y lloraba todo el día. Con la guía de perros rescatados cambió todo.',
    name: 'Martín D.',
    location: 'Mendoza — Dueño de un mestizo',
  },
  {
    quote: 'La planilla de 21 días me ordenó. Ver el avance tachado me hizo no abandonar a los 3 días.',
    name: 'Belén S.',
    location: 'Mar del Plata — Dueña de un Caniche',
  },
  {
    quote: 'Pedí presupuesto a un adiestrador y salía 10 veces más. Con esto lo resolví sola en casa.',
    name: 'Rocío V.',
    location: 'Salta — Dueña de un Border Collie',
  },
  {
    quote: 'Dejó de romper la puerta en la primera semana. El ritual de salida fue clave.',
    name: 'Gastón L.',
    location: 'Neuquén — Dueño de un Ovejero',
  },
]

export interface PainPoint {
  title: string
  text: string
}

export const painPoints: PainPoint[] = [
  {
    title: 'Volvés y encontrás destrozos',
    text: 'Muebles rotos, puertas arañadas, charcos en el piso, otra vez.',
  },
  {
    title: 'Se lo escucha llorar apenas te vas',
    text: 'Ladridos y lloriqueos que no paran, y los vecinos ya se quejan.',
  },
  {
    title: 'Sentís que le fallás',
    text: 'Esa culpa incómoda de "abandonarlo" cada vez que salís de tu casa.',
  },
  {
    title: 'Ya probaste de todo',
    text: 'Juguetes, premios, dejar la tele prendida… y nada cambia en serio.',
  },
  {
    title: 'No sabés por dónde empezar',
    text: 'Tips sueltos de internet, sin un método claro detrás.',
  },
  {
    title: 'Evitás hacer planes',
    text: 'Dejaste de salir tranquilo por miedo a lo que vas a encontrar al volver.',
  },
  {
    title: 'Pensaste en pagar un adiestrador',
    text: 'Pero los precios por hora son imposibles de sostener.',
  },
  {
    title: 'Cada semana que pasa, empeora',
    text: 'Sin un protocolo claro, el hábito se afirma cada vez más.',
  },
]

export interface Audience {
  title: string
  text: string
  tag?: string
}

export const audiences: Audience[] = [
  {
    title: 'Trabajás fuera de casa',
    text: 'Dejás a tu perro solo varias horas por trabajo, estudio o compromisos diarios.',
  },
  {
    title: 'Entrenás desde tu casa',
    text: 'No necesitás adiestrador presencial, equipamiento especial ni collares. Solo el método.',
  },
  {
    title: 'Perro adoptado o con trauma previo',
    text: 'Guía especial para casos de ansiedad por historial de abandono o rescate.',
    tag: 'NUEVO',
  },
  {
    title: 'Buscás resultados en semanas, no meses',
    text: 'Vas por calma real en 21 días, con un protocolo medible y ordenado.',
  },
]

export const methodPills: string[] = [
  '+140 pág.',
  'Protocolo de 21 días',
  'Diagnóstico',
  'Rutinas',
  'Planificación',
  'Primeros auxilios',
  'Contención',
  'Prevención',
  'Vínculo',
  'Autorregulación',
  'Seguimiento',
]

export const skills: string[] = [
  'Tolerancia a la soledad',
  'Calma en la salida',
  'Autocontrol emocional',
  'Confianza y vínculo',
  'Reducción de ladridos',
  'Fin de los destrozos',
]

export interface Tomo {
  id: string
  title: string
  subtitle: string
  description: string
  bullets: string[]
}

export const tomos: Tomo[] = [
  {
    id: 'T1',
    title: 'No es tu culpa',
    subtitle: 'Lo que nadie te explicó antes',
    description:
      'Entendé por qué tu perro sufre cuando te vas y por qué no tiene nada que ver con rencor ni mala conducta. Dejá atrás la culpa antes de empezar el método.',
    bullets: ['Causa real de la ansiedad', 'Test de autodiagnóstico', 'Punto de partida claro'],
  },
  {
    id: 'T2',
    title: 'Las señales que ya te está dando',
    subtitle: 'Detectalo antes del destrozo',
    description:
      'Tu perro avisa mucho antes de romper algo. Aprendé a leer las señales previas para intervenir cuando todavía es fácil revertirlo.',
    bullets: ['Mapa de señales tempranas', 'Registro de conducta diario', 'Niveles de intensidad'],
  },
  {
    id: 'T3',
    title: 'El ritual de salida que lo calma',
    subtitle: 'Resultado visible desde el día 1',
    description:
      'Una secuencia corta y repetible para los minutos previos a irte, que le enseña a tu perro que tu salida no es una emergencia.',
    bullets: ['Secuencia paso a paso', 'Qué hacer y qué evitar', 'Checklist de 30 segundos'],
  },
  {
    id: 'T4',
    title: '21 días para que aprenda a estar solo',
    subtitle: 'El protocolo central del método',
    description:
      'El corazón del sistema: tres semanas de ejercicios progresivos de tolerancia a la soledad, con objetivos claros para cada día.',
    bullets: ['Plan día por día', 'Progresión por semana', 'Qué hacer si retrocede'],
  },
  {
    id: 'T5',
    title: 'Primeros auxilios anti-destrozos',
    subtitle: 'Contención inmediata mientras avanzás',
    description:
      'Medidas de contención para aplicar hoy mismo y proteger tu casa mientras el protocolo de 21 días hace su trabajo de fondo.',
    bullets: ['Zona segura en casa', 'Enriquecimiento de urgencia', 'Manejo de ladridos'],
  },
  {
    id: 'T6',
    title: 'Los errores que sin saberlo empeoran todo',
    subtitle: 'Por qué nada de lo anterior funcionó',
    description:
      'Las despedidas largas, los retos al volver y otros gestos bienintencionados que refuerzan la ansiedad. Corregilos antes de seguir.',
    bullets: ['Los 9 errores más comunes', 'Cómo corregir cada uno', 'Qué no hacer al volver'],
  },
  {
    id: 'T7',
    title: 'Cuándo pedir ayuda y cómo sostener el cambio',
    subtitle: 'Resultados que se mantienen en el tiempo',
    description:
      'Cómo mantener la calma conseguida en vacaciones, mudanzas o cambios de rutina, y cuándo sí conviene sumar un profesional.',
    bullets: ['Señales de alerta', 'Plan de mantenimiento', 'Cómo elegir profesional'],
  },
]

export interface Bono {
  id: string
  title: string
  text: string
  image: string
  alt: string
}

export const bonos: Bono[] = [
  {
    id: 'B1',
    title: 'Planilla de Seguimiento 21 Días',
    text: 'Calendario imprimible para tachar el avance día a día del protocolo.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8b29781d-00a8-48e1-a764-a1baa112678d.jpg',
    alt: 'Planilla imprimible de 21 días con casilleros para tachar',
  },
  {
    id: 'B2',
    title: 'Checklist Salida sin Drama',
    text: 'Lista rápida para pegar en la puerta y aplicar en 30 segundos.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b9430df5-be07-4ab9-9d3b-746da1a9cfd8.jpg',
    alt: 'Checklist para pegar en la puerta antes de salir',
  },
  {
    id: 'B3',
    title: 'Guía de Enriquecimiento Casero',
    text: 'Juguetes y actividades anti-ansiedad con materiales que ya tenés en casa.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e0e08dfa-4101-4ee2-96ab-58aec489e505.jpg',
    alt: 'Juguetes caseros de enriquecimiento para perros',
  },
  {
    id: 'B4',
    title: 'Guía de Sonidos de Calma',
    text: 'Qué sonido ambiente ayuda a bajar el estrés y cómo usarlo bien.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/61551d7e-49c4-40b5-833c-c8bc62af4e18.jpg',
    alt: 'Perro descansando junto a un parlante con sonido ambiente',
  },
  {
    id: 'B5',
    title: 'Diario del Vínculo',
    text: 'Registro emocional para ver cómo crece la confianza día a día.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/99eb650b-9ea8-4120-830b-ab67824eedfb.jpg',
    alt: 'Cuaderno de registro del vínculo con gráfico de progreso',
  },
]

export interface ComparisonRow {
  without: string
  with: string
}

export const comparisonRows: ComparisonRow[] = [
  { without: 'Destrozos cada semana', with: 'Casa intacta en 21 días' },
  { without: 'Salís de casa con culpa', with: 'Salís tranquilo, sin miedo a lo que vas a encontrar' },
  { without: 'Tips sueltos sin resultado', with: 'Protocolo día a día, medible y ordenado' },
  { without: 'Vecinos quejándose por ladridos', with: 'Perro en calma, sin quejas' },
  { without: 'Adiestrador a $/hora', with: 'Método completo por un pago único' },
  { without: 'Ansiedad que empeora con el tiempo', with: 'Vínculo que se fortalece día a día' },
  { without: 'Cero estructura visible de avance', with: 'Planilla de seguimiento con progreso real' },
  { without: 'Sin saber si necesitás ayuda profesional', with: 'Guía clara de cuándo y cómo pedirla' },
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Cómo recibo la guía después de comprar?',
    answer:
      'Apenas se acredita el pago recibís un mail con el enlace de descarga. Son PDF digitales: los abrís en el celular, la compu o los imprimís. El acceso es inmediato, en unos 5 minutos.',
  },
  {
    question: '¿Sirve para cualquier raza o edad de perro?',
    answer:
      'Sí. El protocolo trabaja sobre la conducta, no sobre la raza. Incluye ajustes para cachorros, adultos y perros senior, y para razas más sensibles o más energéticas.',
  },
  {
    question: '¿Necesito collares o equipamiento especial?',
    answer:
      'No. Nada de collares eléctricos, antiladridos ni castigos. Se trabaja con rutina, manejo del ambiente y enriquecimiento con cosas que ya tenés en casa.',
  },
  {
    question: '¿Los 5 bonos están incluidos en el precio?',
    answer:
      'Sí. Los 5 bonos estratégicos vienen completos y sin costo extra dentro del pack de $19.990. El Kit de Emergencia Total™ es aparte: es un complemento opcional que se ofrece al finalizar la compra.',
  },
  {
    question: '¿Sirve si vivo en departamento?',
    answer:
      'Especialmente. Hay una sección dedicada a espacios chicos, vecinos cerca y manejo de ladridos en edificios.',
  },
  {
    question: '¿Funciona con perros adoptados o rescatados?',
    answer:
      'Sí, y tiene una guía específica para ansiedad por historial de abandono. El avance suele ser más gradual, por eso el protocolo incluye una progresión más lenta para esos casos.',
  },
  {
    question: '¿Qué diferencia tiene con tips gratis de internet?',
    answer:
      'Los tips sueltos no tienen orden ni progresión. Acá tenés un protocolo de 21 días con objetivo por día, planillas de seguimiento y qué hacer cuando algo no sale.',
  },
  {
    question: '¿Qué es el Kit de Emergencia Total™ y cuánto sale?',
    answer:
      'Es un complemento opcional con el Plan de Choque 72 Horas y el Kit de Primeros Auxilios, pensado para quien no puede esperar 21 días. No está incluido en el pack: se ofrece con un precio especial al finalizar tu compra y podés sumarlo o rechazarlo sin perder nada de lo que ya compraste.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí: 7 días. Probás el ritual de salida, arrancás el protocolo, usás las planillas. Si no es lo que esperabas, te devolvemos el 100%. Sin preguntas, sin formularios.',
  },
]
